module.exports = __webpack_public_path__ + "img/C03TechStoneThrower_ua.2db9ded0.webp";